import React, { useState } from "react"
import Link from 'gatsby-link'
import Logo from "src/images/logo-shorter.svg"
import DesktopNavigation from './DesktopNavigation'
import MobileNavigation from './MobileNavigation'

const Navigation = ({ settings }) => {

    const [dropdownToggled, setDropdownToggled] = useState(false)

    const handleDropdownToggled = (props) => {
        setDropdownToggled(props)
    };

    return (
        <header className={`bg-white w-full fixed top-0 shadow-lg ${dropdownToggled ? 'z-30' : 'z-20'}`}>
            <nav className="mx-auto px-6 lg:px-12" aria-label="Top">
                <div className="w-full flex items-center justify-between lg:border-none ml-auto">
                    <div className="flex items-center w-full">
                        <Link className="w-24 lg:w-28" to="/">
                            <Logo className="w-full" />
                        </Link>
                        <DesktopNavigation {...settings} handleDropdownToggled={handleDropdownToggled}/>
                        <MobileNavigation {...settings} handleDropdownToggled={handleDropdownToggled}/>
                    </div>
                </div>
            </nav>
        </header>    
    )
}

export default Navigation;
